/**
 *	@fileOverview Converts row string to number
 *	@param {string} row
 *
 *	@return {number}
 */
export default function(row: string): number
{
	return parseInt(row, 10);
}